import React from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {GetCurrentLocale} from "../../components/Utils";
import {THEME_IMG} from "../../app/AppConfig";
import {SpinnerOnTop} from "../../components/SpinnerOnTop";
import {AssociatedProduct} from "../Entity/Product";


interface ComponentProps {
  associatedProduct: AssociatedProduct[] | null,
  isRequestingAssociatedProduct: boolean
}
const ProductsRelated: React.FC<ComponentProps> = ({associatedProduct,isRequestingAssociatedProduct}: ComponentProps) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)

  return (
    <>
      {
        isRequestingAssociatedProduct ?
          <SpinnerOnTop/>
          :
          associatedProduct && associatedProduct.length > 0 ?
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">{t('you_may_also_like')} </h5>
              {
                associatedProduct.map((productRelatedItem: AssociatedProduct) => {
                    return(
                      <article className="itemside mb-3" key={productRelatedItem.code}>
                        <a href="#" className="aside">
                          <img src={THEME_IMG + "/images/esm-no-product-image.png"} width="96" height="96" className="img-md img-thumbnail" alt={productRelatedItem.name}/>
                        </a>
                        <div className="info">
                          <a href="#" className="title mb-1">
                            <strong>
                              {productRelatedItem.name}
                            </strong> <br/>
                            {productRelatedItem.brand} {productRelatedItem.reference} </a>
                          <strong className="price"> {productRelatedItem.price / 100} €</strong>
                        </div>
                      </article>
                    )
                  }
                )
              }
            </div>
          </div>
            : null
      }
    </>
  )
}
export default ProductsRelated;


